import React from 'react';
import { useNavigate } from 'react-router-dom';
import TextWinds from '../../../components/common/TextWinds';
import {
  classInfo,
  myLearningInfoType,
} from '../../../constants/types/student-type';
import instance from '../../../api/axios/utils.ts/instance';
import { useAppDispatch } from '../../../store/hook';
import { openAlert } from '../../../store/features/modalSlice';
import { getErrorMessages } from '../../../api/utils/util-func';
import { StudentStatusTag } from './StudentStatusTag';
interface StudentClassItemProps {
  data: myLearningInfoType;
  classInfos: classInfo[];
}
const StudentClassItem = ({ data, classInfos }: StudentClassItemProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const pageMoveHander = async () => {
    try {
      const result = await instance.get(
        '/v1/student/class/' + data.myLearning.id,
      );
      if (result.data.statusCode === 200) {
        navigate(`/student/homework/${data.myLearning.id}`);
      }
    } catch (e) {
      dispatch(openAlert({ message: getErrorMessages(e) }));
    }
  };
  return (
    <div
      className="group h-auto w-full cursor-pointer rounded-lg bg-white bg-clip-border shadow-card"
      onClick={() => {
        pageMoveHander();
      }}
    >
      <div className="overflow-hidden rounded-t-lg">
        <img
          src={data.myLearning.thumbnail}
          className="h-[150px] w-full object-cover transition-transform duration-200 ease-in-out group-hover:scale-105"
        />
      </div>
      <div className="h-auto px-3.5 py-3">
        <div className="flex gap-2">
          <img src="/images/common/icon_pencil.svg" />
          <TextWinds type={'title_h4'} children={data.myLearning.name} />
        </div>

        <div className="mt-4 flex flex-row items-end justify-between">
          <StudentStatusTag
            studentStatus={
              classInfos.find((info) => info.classId === data.myLearning.id)
                ?.studentStatus
            }
          />
          <TextWinds
            type={'caption1'}
            children={`담당 선생님 : ${data.myLearning.teacherName}`}
          />
        </div>
      </div>
    </div>
  );
};

export default StudentClassItem;
